import { MenuItem, SxProps, TextField, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { SexType } from "../../../types";

const capitalize = (s: string): string => {
  return s.charAt(0).toUpperCase() + s.slice(1);
};

const UNSPECIFIED = "__unspecified__";

interface AthleteFormSexTypeSelectProps {
  value: SexType | null;
  onChange: (type: SexType | null) => void;
  required?: boolean;
  error?: boolean;
  helperText?: React.ReactNode;
  disabled?: boolean;
  tooltip?: React.ReactNode;
  sx?: SxProps;
}

const AthleteFormSexTypeSelect = ({
  value,
  onChange,
  required,
  error,
  helperText,
  disabled = false,
  tooltip,
  sx = { width: "120px" },
}: AthleteFormSexTypeSelectProps) => {
  const { t } = useTranslation();
  const options: SexType[] = ["male", "female"];

  const [menuOpen, setMenuOpen] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  return (
    <Tooltip
      title={tooltip ?? ""}
      open={Boolean(tooltip) && tooltipOpen && !menuOpen}
      onOpen={() => setTooltipOpen(true)}
      onClose={() => setTooltipOpen(false)}
      disableFocusListener
    >
      <TextField
        sx={sx}
        select
        label="Sex"
        fullWidth
        required={required}
        disabled={disabled}
        error={error}
        helperText={helperText}
        value={value ?? UNSPECIFIED}
        onChange={e => onChange(e.target.value === UNSPECIFIED ? null : (e.target.value as SexType))}
        SelectProps={{ onOpen: () => setMenuOpen(true), onClose: () => setMenuOpen(false) }}
      >
        <MenuItem value={UNSPECIFIED}>{t("athlete.form.basicInformation.sex.unspecified")}</MenuItem>
        {options.map(option => (
          <MenuItem key={option} value={option}>
            {capitalize(option)}
          </MenuItem>
        ))}
      </TextField>
    </Tooltip>
  );
};

export default AthleteFormSexTypeSelect;
